import { ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import QueryString from 'query-string';
import { useEffect, useState } from 'react';
import { RouteChildrenProps, useHistory } from 'react-router';
import {
  useIncrementShefPostClickCountMutation,
  useIncrementShefPostViewCountMutation,
} from 'src/gqlReactTypings.generated.d';
import { useTracker } from 'src/shared/hooks/useTracker';

export const useConsumerOrderTracking = (props: RouteChildrenProps) => {
  const { location } = props;
  const history = useHistory();
  const tracker = useTracker();
  const [isTracking, setIsTracking] = useState(false);

  const parsedQs = QueryString.parse(location.search);
  const shefPostLocation = parsedQs[QueryParams.SHEF_POST_LOCATION]?.toString() ?? '';
  const shefPostShefId = parsedQs[QueryParams.SHEF_POST_SHEF_ID]?.toString() ?? '';
  const shefPostId = parsedQs[QueryParams.SHEF_POST_ID]?.toString() ?? '';

  const [incrementShefPostClickCount] = useIncrementShefPostClickCountMutation();
  const [incrementShefPostViewCount] = useIncrementShefPostViewCountMutation();

  const filteredQueryParams = Object.keys(parsedQs)
    .filter(
      (key) =>
        ![
          QueryParams.SHEF_POST_LOCATION.toString(),
          QueryParams.SHEF_POST_SHEF_ID.toString(),
          QueryParams.SHEF_POST_ID.toString(),
        ].includes(key)
    )
    .reduce((acc, cur) => ({ ...acc, [cur]: parsedQs[cur] }), {});

  useEffect(() => {
    if (shefPostLocation && shefPostId && !isTracking) {
      setIsTracking(true);
      const shefPostLocations = {
        menu: 'menu',
        email: 'email',
        feed: 'feed',
      };

      history.replace({
        search: QueryString.stringify(filteredQueryParams),
      });

      const track = async () => {
        tracker.track(ClientEvents.SHEF_POST_VIEW, {
          shefId: shefPostShefId,
          postId: shefPostId,
          location: shefPostLocations[shefPostLocation] ?? shefPostLocations.feed,
        });

        if ([shefPostLocations.email, shefPostLocations.feed].includes(shefPostLocation)) {
          await incrementShefPostClickCount({
            variables: {
              id: shefPostId,
            },
          });
        }

        await incrementShefPostViewCount({
          variables: {
            id: shefPostId,
          },
        });
        setIsTracking(false);
      };

      track().catch((error) => {
        console.error(error);
      });
    }
  }, [
    filteredQueryParams,
    history,
    incrementShefPostClickCount,
    incrementShefPostViewCount,
    isTracking,
    shefPostId,
    shefPostLocation,
    shefPostShefId,
    tracker,
  ]);
};
